import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import { useI18n } from 'vue-i18n';
import { IncrediTab, IncrediTabList } from 'incredi-ui';
import { Routes } from '@/router/router.const';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-tabs',
  setup(__props) {

const { t } = useI18n();

const tabs = [
  { name: Routes.BuildSummary, title: t('workloads.details.summaryTab.title'), index: 0 },
  { name: Routes.BuildPerformanceMetrics, title: t('workloads.details.performanceMetricsTab.title'), index: 1 },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(IncrediTabList), null, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
              return _createVNode(_unref(IncrediTab), {
                key: tab.index,
                index: tab.index,
                title: tab.title,
                "data-testid": tab.name,
                active: _ctx.$route.name === tab.name,
                class: "!w-fit",
                onClick: ($event: any) => (_ctx.$router.replace({ name: tab.name, params: { id: _ctx.$route.params.id } }))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tab.title), 1)
                ]),
                _: 2
              }, 1032, ["index", "title", "data-testid", "active", "onClick"])
            }), 64))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})